export default __webpack_public_path__ + "images/8c696514201beed4fc2e7ab95f6849e9.jpg";